import React from 'react';

import styled from 'styled-components';

import Button from './Components/Button';
import InputField from './Components/InputField';

const Wrapper = styled.div`
  padding-top: 120px;
  max-width: 400px;
  margin: auto;
`;

const Paper = styled.div`
  border: 1px solid #dadce0;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  background-color: #fff;
`;

const InputWrapper = styled.div`
  padding: 24px;
`;

const Form = styled.form``;

const ActionWrapper = styled.div`
  padding-bottom: 24px;
  color: rgba(0, 0, 0, 0.65);
`;

const Description = styled.div`
  width: 100%;
  margin-top: 5px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
`;

const PasswordStrength = styled.div`
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.65);
`;

const Error = styled.div`
  border: 2px solid #f00;
  background: #f88;
  padding: 15px;
  font-size: 12px;
  white-space: pre-wrap;
`;

const PasswordStrengthValue = styled.span``;

const Requirements = styled.div``;

interface Props {
  loading: boolean;
  error?: string;
  password: string;
  setPassword: (value: string) => void;
  passwordError: string;
  handlePasswordBlur?: () => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  confirmPasswordError: string;
  handleConfirmPasswordBlur?: () => void;
  passwordStrength: string;
  handleChangePassword: () => void;
}

const ResetPasswordView = ({
  loading,
  error,
  password,
  setPassword,
  passwordError,
  handlePasswordBlur,
  confirmPassword,
  setConfirmPassword,
  confirmPasswordError,
  handleConfirmPasswordBlur,
  passwordStrength,
  handleChangePassword,
}: Props) => {
  return (
    <Wrapper>
      <Paper>
        <InputWrapper>
          <Form>
            <InputField
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              label="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={handlePasswordBlur}
              error={passwordError}
              type="password"
            />

            <Description>
              <PasswordStrength>
                {'Password Strength: '}
                <PasswordStrengthValue>{passwordStrength}</PasswordStrengthValue>
              </PasswordStrength>
              <Requirements>
                The minimum password length is 8 characters. Do not use passwords from other sites
                or options that attackers can easily pick up.
              </Requirements>
            </Description>

            <InputField
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              label="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onBlur={handleConfirmPasswordBlur}
              error={confirmPasswordError}
              type="password"
            />
          </Form>

          {error && <Error>{error}</Error>}
        </InputWrapper>
        <ActionWrapper>
          <Button onClick={handleChangePassword} disabled={loading}>
            Change Password
          </Button>
        </ActionWrapper>
      </Paper>
    </Wrapper>
  );
};

export default ResetPasswordView;
